const defaultGetVisitedUrls = () => ({});

function compileCustomExpression(customExpression, options = {}) {
  if (!customExpression) {
    return null;
  }

  const {
    filtrex,
    getTotalTime = defaultGetVisitedUrls,
    getSessionTime = defaultGetVisitedUrls,
  } = options;

  if (!filtrex) {
    throw new Error('Filtrex is not loaded.');
  }

  const inArray = (array, value, property) => {
    if (!array) {
      return false;
    }

    return array.some((item) => {
      if (property) {
        return filtrex.useDotAccessOperatorAndOptionalChaining(property, null, item, null) === value;
      }

      return item === value;
    });
  };

  const visitedUrl = (url) => {
    const visitedUrls = getTotalTime();
    return Object.keys(visitedUrls).some(u => u.match(url));
  };

  const visitedUrlThisSession = (url) => {
    const visitedUrls = getSessionTime();
    return Object.keys(visitedUrls).some(u => u.match(url));
  };

  return filtrex.compileExpression(customExpression, {
    customProp: filtrex.useDotAccessOperatorAndOptionalChaining,
    extraFunctions: {
      inArray,
      visitedUrl,
      visitedUrlThisSession,
    },
    constants: {
      true: true,
      false: false,
    },
  });
}

module.exports = {
  compileCustomExpression,
};
